import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import immutableCreatorSelector from '../../../selectors/immutableCreatorSelector';
import { ElementActions } from '../../../actions/element';
import { ProjectActions } from '../../../actions/project';
import { validateAndDispatch } from '../../../helpers/form';

const currentProjectIdSelector = state =>
  state.projects.get('currentProjectId');
const rootElementIdSelector = state => state.projects.get('rootElementId');
const P6FormSelector = state => {
  const selector = formValueSelector('P6');
  return selector(state, 'module', 'file', 'percentComplete');
};

const ExportDefaultTabSelector = immutableCreatorSelector(
  [currentProjectIdSelector, rootElementIdSelector, P6FormSelector],
  (currentProjectId, rootElementId, p6Form) => {
    return {
      rootElementId,
      currentProjectId,
      fields: p6Form,
    };
  },
);

class P6ExportModule extends Component {
  static propTypes = {
    rootElementId: PropTypes.string,
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
  };

  state = {
    response: null,
    uploadedFile: null,
    accepted: [],
    rejected: [],
  };

  submit = (values, dispatch) => {
    // debugger;
    const { currentProjectId, reset, rootElementId } = this.props;

    // debugger;
//    const validation = new Checkit({});
    const validation = {};

    const module = values.module;
    const file = values.importFile[0];

    return validateAndDispatch(
      dispatch,
      ProjectActions.exportFile(
        module,
        file,
        rootElementId,
        currentProjectId,
      ),
      validation,
      values,
    ).then(result => {
      const response = result.result.response;
      this.setState({
        response,
      });
      reset();
      dispatch(ElementActions.getElements(currentProjectId));
      dispatch(ProjectActions.getProject(currentProjectId));
      // dispatch(ElementActions.getRelationships(rootElementId, ['children', 'parent', 'childrenOfChildren']));
    });

  }

  render = () => {
    const {
      handleSubmit,
      submitting,
    } = this.props;

    // const { response } = this.state;

    // const result = response ? response.result[0] : undefined;

    const submitButton = (
      <form onSubmit={handleSubmit(this.submit)}>
       <button
           type="submit"
           className="btn btn-primary mt-2 mr-2"
           disabled={submitting}
         >Import</button>
         </form>);

    const form = (
      <section>
        {submitButton}
      </section>
    );

    const responseData = undefined;
    const uploader = form;

    return responseData ? responseData : uploader;
  }
}

@connect(ExportDefaultTabSelector)
@reduxForm({
  form: 'P6',
  initialValues: {
    module: 'P6',
    percentComplete: 0,
  },
})
export default class P6ExportModuleContainer extends Component {
  static propTypes = {
    rootElementId: PropTypes.string,
    currentProjectId: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  render() {
    return <P6ExportModule {...this.props} />;
  }
}



// WEBPACK FOOTER //
// ./src/views/ProjectSettings/Exports/P6Export.js